export const enAdminRegisterForm = {
  CG41title: 'Alumni registration form setting confirmation',
  CG41text1: 'The following is when the alumni were invited',
  CG41text2: 'It will be an item to be entered by the alumni themselves.',
  CG41requiredText: 'Name (Kanji), Name (Kana), Display name, Email address, Date of birth, Current position information (Affiliation, Job type, Affiliation period)',
  CG41addText:
    'Department name at the time of enrollment, period of enrollment, employee ID at the time of enrollment, email address at the time of enrollment, name at the time of enrollment (Kanji)',
  CG40unnecessary: 'Unnecessary',
  CG40required: 'Mandatory',
  CG40any: 'Any',
  CG40updateFailed: 'Update failed',
  CG40Yelloop_Check_info1: '以下の項目はプール型では必須入力です。',
  CG40Yelloop_Check_info2: '再入社意欲、特に知りたい情報',
  CG40copyingformsettings: 'Copy Form Settings',
  CG40copyfieldfromotherform: 'You can copy fields from other form settings.',
  CG40cannotcopyfromcurrent: 'You cannot copy the content you are currently editing.',
  CG40btncopy: 'Copy',
  CG40titlecopyconfirm: 'Confirm Copy of Alumni Registration Form',
  CG40copyfromhere: 'Copy from here.',
  CG40notechangeswilldiscarded: 'Please note that any changes you are currently editing will be discarded.',
  CG40handlecopy: 'Copy',
  CG40titlecopysuccess: 'Alumni Registration Form Copy Complete',
  CG40copied: 'Copied.',
  CG40selectformcopy: 'Please select the form you wish to copy',
}
